import { gql }  from '@apollo/client';

const SET_PRIMARY_INSURANCE = gql`
  mutation ($memberId: ID!, $primaryInsurance: InsuranceInput!, $groupId: ID) {
    setPrimaryInsurance(
      memberId: $memberId,
      primaryInsurance: $primaryInsurance,
      groupId: $groupId
    ) {
      success
      errors
    }
  }
`;

export default SET_PRIMARY_INSURANCE;
